import { Textarea, TextAreaProps } from "@heroui/react";
import { Controller, useFormContext } from "react-hook-form";

function TextAreaInput({
    name,
    ...props
}: { name: string } & Partial<TextAreaProps>) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange, onBlur, value },
                fieldState: { error },
            }) => (
                <Textarea
                    {...props}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    error={error?.message}
                />
            )}
        />
    );
}

export default TextAreaInput;
